/**
 * Module: Book
 * Parent Blocks:
 * - list
 * Notes:
 * - Does not render on the FE. Handled with React
 */

const save = () => {
  return (
    null
  );
};

export default save;
